import type { OnboardingOnboardingAnswers } from '@customerio/hydra-ui-api';
import type { GoalLabel } from './answer-recap';
import { getStartingPointVariant, type StartingPointVariant } from './steps';

const GOAL_GERUNDS = new Map<string, string>(
  Object.entries({
    'Activate new members': 'activating new members',
    'Win back lapsed members': 'winning back lapsed members',
    'Drive repeat purchases': 'driving repeat purchases',
    'Re-engage inactive people': 're-engaging inactive people',
    'Reduce cart abandonment': 'reducing cart abandonment',
  } satisfies Record<GoalLabel, string>),
);

const FIRST_ASSET_NOUNS = {
  workflows: 'workflow',
  broadcasts: 'broadcast',
  transactional: 'transactional message',
  user_segmentation: 'segment',
} as const satisfies Record<StartingPointVariant, string>;

export const WORKSPACE_SETUP_LABEL = 'Setting up your workspace…';
const GENERIC_GOAL_LINE = 'Optimizing for your outcomes…';

export function agentHandoffLabels(answers: OnboardingOnboardingAnswers | undefined): string[] {
  const gerund = answers?.goal == null ? undefined : GOAL_GERUNDS.get(answers.goal);
  const goalLine = gerund == null ? GENERIC_GOAL_LINE : `Optimizing for ${gerund}…`;
  const asset = FIRST_ASSET_NOUNS[getStartingPointVariant(answers?.starting_point)];

  return [WORKSPACE_SETUP_LABEL, goalLine, `Preparing your first ${asset}…`];
}
